import { MenuItem } from '@mui/material';
import React from 'react';
import { GlobalConfiguration } from '../../../models/GlobalConfiguration';
import { formatModelDisplayName } from '../../../utils/ModelOptions';
import StyledFieldDescription from '../../styles/StyledFieldDescription';
import { StyledInput } from '../../styles/StyledInputs';
import StyledSection from '../../styles/StyledSection';
import { StyledFieldRow, StyledHeading, StyledLabel } from '../../styles/styles';
import ConfigFieldLabel from './ConfigFieldLabel';
import { ADVANCED_MODEL_FIELDS, GLOBAL_CONFIG_FIELD_LABELS } from './globalConfigFieldConfig';

type AIModelsSectionProps = {
  config: GlobalConfiguration;
  dirtyFields: Set<string>;
  dropdownSx: object;
  onChange: (field: string, value: unknown) => void;
  getDropdownOptions: (fieldKey: string) => string[];
};

export default function AIModelsSection({
  config,
  dirtyFields,
  dropdownSx,
  onChange,
  getDropdownOptions,
}: AIModelsSectionProps) {
  return (
    <StyledSection tone="tone1">
      <StyledHeading tone="tone1" headerVariant="heading2">
        AI Models
      </StyledHeading>
      {ADVANCED_MODEL_FIELDS.map((fieldKey) => (
        <StyledFieldRow
          stacked
          sx={{ mb: 2 }}
          key={`${fieldKey}-${getDropdownOptions(fieldKey).join(',')}-${(config as unknown as Record<string, unknown>)[fieldKey]}`}
        >
          <StyledLabel stacked>
            <ConfigFieldLabel
              fieldKey={fieldKey}
              label={GLOBAL_CONFIG_FIELD_LABELS[fieldKey]}
              dirtyFields={dirtyFields}
            />
          </StyledLabel>
          <StyledFieldDescription stacked>
            Model used for {GLOBAL_CONFIG_FIELD_LABELS[fieldKey].toLowerCase()}.
          </StyledFieldDescription>
          <StyledInput
            select
            sx={dropdownSx}
            value={(config as unknown as Record<string, unknown>)[fieldKey] || ''}
            onChange={(e) => onChange(fieldKey, e.target.value)}
          >
            {getDropdownOptions(fieldKey).map((opt) => (
              <MenuItem key={opt} value={opt}>
                {formatModelDisplayName(opt)}
              </MenuItem>
            ))}
          </StyledInput>
        </StyledFieldRow>
      ))}
    </StyledSection>
  );
}
